import { RESET_ALL_STATES } from "../actions/actions";
import {
  CONTACT_OTP_GENERATE_REQUEST,
  CONTACT_OTP_GENERATE_SUCCESS,
  CONTACT_OTP_GENERATE_FAILURE,
  CONTACT_OTP_VALIDATE_REQUEST,
  CONTACT_OTP_VALIDATE_SUCCESS,
  CONTACT_OTP_VALIDATE_FAILURE,
  CONTACT_OTP_RESET,
} from "../actions/actionTypes";

const channelInitial = {
  isLoading: false,
  error: null,
  verified: false,
  sent: false,
  transactionId: null,
};

const initialState = {
  phone: { ...channelInitial },
  email: { ...channelInitial },
};

const contactOtpReducer = (state = initialState, action) => {
  const { channel } = action.payload || {};

  switch (action.type) {
    case CONTACT_OTP_GENERATE_REQUEST:
      return {
        ...state,
        [channel]: {
          ...state[channel],
          isLoading: true,
          error: null,
          transactionId: null,
        },
      };
    case CONTACT_OTP_GENERATE_SUCCESS:
      return {
        ...state,
        [channel]: {
          ...state[channel],
          isLoading: false,
          error: null,
          sent: true,
          transactionId: action.payload.transactionId || null,
        },
      };
    case CONTACT_OTP_GENERATE_FAILURE:
      return {
        ...state,
        [channel]: {
          ...state[channel],
          isLoading: false,
          error: action.payload.message,
          transactionId: null,
        },
      };
    case CONTACT_OTP_VALIDATE_REQUEST:
      return {
        ...state,
        [channel]: { ...state[channel], isLoading: true, error: null },
      };
    case CONTACT_OTP_VALIDATE_SUCCESS:
      return {
        ...state,
        [channel]: {
          ...state[channel],
          isLoading: false,
          error: null,
          verified: true,
        },
      };
    case CONTACT_OTP_VALIDATE_FAILURE:
      return {
        ...state,
        [channel]: {
          ...state[channel],
          isLoading: false,
          error: action.payload.message,
        },
      };
    case CONTACT_OTP_RESET:
    case RESET_ALL_STATES:
      return initialState;
    default:
      return state;
  }
};

export default contactOtpReducer;
